import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { SortType } from 'services/store';

type PropsType = {
  initialValue: SortType;
  onUpdate: (popularity: SortType) => void;
};

const SortingFilter = ({ initialValue, onUpdate }: PropsType) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [currentSortingType, setCurrentSortingType] =
    useState<SortType>(initialValue);

  useEffect(() => {
    onUpdate(currentSortingType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSortingType]);

  const handleChange = (event: SelectChangeEvent) => {
    setCurrentSortingType(event.target.value as SortType);
  };

  return (
    <FormControl
      hiddenLabel
      sx={{
        boxShadow: 'none',
        '.MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      <Select
        labelId="popular-recent-filter"
        id="popular-recent-filter"
        value={currentSortingType}
        sx={{
          color: theme.palette.grey[400],
          '.MuiSvgIcon-root': { color: theme.palette.grey[400] },
        }}
        onChange={handleChange}
      >
        <MenuItem value={SortType.Popular}>
          {t('filtersBar:sortBy:popular')}
        </MenuItem>
        <MenuItem value={SortType.Recent}>
          {t('filtersBar:sortBy:recent')}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SortingFilter;
